import apiClient from '@/scripts/api/apiClient';

/**
 * Permission API endpoints
 */

// Query key factories
export const permissionKeys = {
  getPermissions: () => ['get', 'permissions'],
  getPermission: (id) => ['get', 'permissions', id],
  createPermission: () => ['create', 'permissions'],
  updatePermission: (id) => ['update', 'permissions', id],
  deletePermission: (id) => ['delete', 'permissions', id],
};

/**
 * Get all permissions
 * @returns {Promise<Array>} List of permissions
 */
export const getPermissions = async () => {
  const response = await apiClient.get('/api/permissions');
  return response.data;
};

/**
 * Get a specific permission by ID
 * @param {string} id - Permission ID
 * @returns {Promise<Object>} Permission details
 */
export const getPermission = async (id) => {
  const response = await apiClient.get(`/api/permissions/${id}`);
  return response.data;
};

/**
 * Create a new permission
 * @param {Object} permissionData - Permission data including name, entity, action, and description
 * @returns {Promise<Object>} Created permission
 */
export const createPermission = async (permissionData) => {
  const response = await apiClient.post('/api/permissions', permissionData);
  return response.data;
};

/**
 * Update an existing permission
 * @param {string} id - Permission ID
 * @param {Object} permissionData - Permission data to update
 * @returns {Promise<Object>} Updated permission
 */
export const updatePermission = async (id, permissionData) => {
  const response = await apiClient.put(`/api/permissions/${id}`, permissionData);
  return response.data;
};

/**
 * Delete a permission
 * @param {string} id - Permission ID
 * @returns {Promise<Object>} Response data
 */
export const deletePermission = async (id) => {
  const response = await apiClient.delete(`/api/permissions/${id}`);
  return response.data;
};
